export const ASSISTANT_INTEREST_PATH = '/dashboard/assistant'

export const ASSISTANT_CHALLENGE_MIN_LENGTH = 180

export const ASSISTANT_CHALLENGE_MAX_LENGTH = 500

export interface AssistantChallengeCounter {
  minRemaining: number
  maxRemaining: number
  canSubmit: boolean
}

export function assistantChallengeCounter (length: number): AssistantChallengeCounter {
  const minRemaining = Math.max(0, ASSISTANT_CHALLENGE_MIN_LENGTH - length)
  const maxRemaining = Math.max(0, ASSISTANT_CHALLENGE_MAX_LENGTH - length)

  return {
    minRemaining,
    maxRemaining,
    canSubmit: length >= ASSISTANT_CHALLENGE_MIN_LENGTH && length <= ASSISTANT_CHALLENGE_MAX_LENGTH
  }
}
